import React from "react";
import "../../styles.css";
import { useState, useEffect } from "react";
import {
  Elements,
  useStripe,
  useElements,
  CardElement,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { axiosReqConfig } from "../../functions/axiosRequest";
import { API_IP, STRIPE_KEY } from "../../global_variables";
import { loadStripe } from "@stripe/stripe-js";

const PaymentModal = ({
  handleClose,
  showModal,
  toggleAlert,
  toggleRefresh,
  clientSecret,
  customerSession,
  totalPrice,
  selectedBooking,
}) => {
  const RETURN_URL = "http://localhost:3000/completion";
  const stripe = useStripe(); // Hook to get the Stripe instance
  const elements = useElements(); // Hook to get the Elements instance (needed for PaymentElement)
  const [isFinished, setIsFinished] = useState(false);
  const [message, setMessage] = useState(null); // To display success/error messages
  const [isLoading, setIsLoading] = useState(false); // To disable button during submission
  // --- Handle Form Submission ---
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission

    // Ensure Stripe.js and Elements are loaded before proceeding
    if (!stripe || !elements) {
      console.log("Stripe.js or Elements has not loaded yet.");
      setMessage("Stripe is not ready. Please wait a moment and try again.");
      return;
    }

    setIsLoading(true); // Disable form during processing
    setMessage(null); // Clear previous messages

    const { error } = await stripe.confirmPayment({
      elements, // Pass the Elements instance
      redirect: "if_required",
    });

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message || "An unexpected error occurred. Try again");
      } else {
        setMessage("An unexpected error occurred. Try again");
        console.error("Stripe confirmPayment error:", error);
      }
    } else {
      // This typically won't be reached if redirect is used,
      // as the user is sent to the return_url.
      // You might handle success state here if redirect='if_required' is NOT used
      // and the payment succeeds without needing redirection (e.g., for some synchronous methods).
      const data = await axiosReqConfig(`${API_IP}/api/payment`, "patch", {
        paymentToken: selectedBooking.transactionId,
        booking_id: selectedBooking.booking_id,
        provider_id: selectedBooking.provider_id,
        platform: "web",
      });
      console.log(selectedBooking.transactionId);
      toggleRefresh();
      setMessage("Your payment has been processed successfully!");
    }

    setIsFinished(true);
    setIsLoading(false); // Re-enable form
  };

  function handleCloseModal() {
    setIsFinished(false);
    setMessage(null);
    setIsLoading(false);
    handleClose();
  }

  if (!showModal) {
    return null;
  }
  return (
    <>
      <div className="startTime-modal-overlay" onClick={handleClose}>
        <div
          className="startTime-modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          {!isFinished ? (
            <form
              id="payment-form"
              onSubmit={handleSubmit}
              className="space-y-4 p-6 bg-white rounded-lg shadow-md max-w-md mx-auto mt-10 font-sans"
            >
              {/* The PaymentElement dynamically displays relevant payment methods */}
              <PaymentElement
                id="payment-element"
                options={{ layout: "tabs" }}
              />

              {/* Submit Button */}
              <button
                disabled={isLoading || !stripe || !elements}
                id="submit"
                className={`payment-modal-button`}
              >
                <span id="button-text">
                  {isLoading ? (
                    <div>
                      <img
                        src={require(`../../images/loading_icon.gif`)}
                        className="BookingProviderIcon"
                      />
                    </div>
                  ) : (
                    `Pay Now $` + `${(totalPrice / 100).toFixed(2)}`
                  )}
                </span>
              </button>

              {/* Show any error or success messages */}
              {message && (
                <div
                  id="payment-message"
                  className={`mt-4 text-sm ${
                    message.includes("error")
                      ? "text-red-600"
                      : "text-green-600"
                  } font-medium p-3 bg-gray-100 rounded-md`}
                >
                  {message}
                </div>
              )}
            </form>
          ) : (
            <div className="payment-alert-content">
              <h4>{message}</h4>
              <button className={`payment-modal-button`} onClick={handleClose}>
                Close
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PaymentModal;
